export interface StaffIdentitySource {
  email: string;
  name?: string | null;
}

export interface StaffIdentity {
  primary: string;
  secondary: string | null;
}

/** A persisted display name leads; legacy accounts keep their existing e-mail identity. */
export function staffIdentity(person: StaffIdentitySource): StaffIdentity {
  const name = person.name?.trim();
  return name
    ? { primary: name, secondary: person.email }
    : { primary: person.email, secondary: null };
}

/** Initials follow the same identity source as the visible label. */
export function staffInitials(person: StaffIdentitySource): string {
  const name = person.name?.trim();
  const parts = name
    ? name.split(/\s+/).filter(Boolean)
    : person.email.replace(/@.*$/, "").split(/[\s._-]+/).filter(Boolean);
  const letters = parts.length >= 2
    ? parts.slice(0, 2).map((part) => Array.from(part)[0] ?? "")
    : Array.from(parts[0] ?? person.email).slice(0, 2);
  return letters.join("").toUpperCase();
}

/** Native select options cannot render two lines, so preserve the same primary/secondary order. */
export function staffOptionLabel(person: StaffIdentitySource): string {
  const identity = staffIdentity(person);
  return identity.secondary
    ? `${identity.primary} — ${identity.secondary}`
    : identity.primary;
}
